module.exports = __webpack_public_path__ + "img/image_15.7a8fb36c.png";